import React, {Component, PropTypes} from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';

import StoryList from '../../components/story-list/story-list';
import TotalCounter from '../../components/total-counter/total-counter';
import CategoryFilter from '../../components/category-filter/category-filter';
import CategoryPanel from '../../components/category-panel/category-panel';
import { CATEGORY_CLASS_MAP } from '../../utils/category-utils';
import { CATEGORY_TIME_MAP } from '../../utils/category-minutes';

import STORIES from '../../utils/stories';

import root from '../../global.cssm';
import styles from './top-stories.cssm';


// A Redux-y reducer. We're not using Redux here because we don't really need to.
// See: https://medium.com/@dan_abramov/you-might-not-need-redux
const filterState = (state={
    currentCategory: null,
    previewCategory: null,
    mobileAction: 'categories',
    activeMedium: null,
}, action) => {
    switch (action.type) {
        case 'SET_FILTER':
            return {
                ...state,
                currentCategory: action.payload,
                previewCategory: null,
                mobileAction: 'categories',
            }
        case 'CLEAR_FILTER':
            return {
                ...state,
                currentCategory: null,
                previewCategory: null,
                mobileAction: 'categories',
            }
        case 'SET_FILTER_PREVIEW':
            return {
                ...state,
                previewCategory: action.payload
            }
        case 'CLEAR_FILTER_PREVIEW':
            return {
                ...state,
                previewCategory: null
            }
        case 'MOBILE_OPEN':
            return {
                ...state,
                mobileAction: 'close'
            }
        case 'MOBILE_CLOSE':
            return {
                ...state,
                mobileAction: 'categories',
            }
        case 'SET_ACTIVE_MEDIUM':
            return {
                ...state,
                activeMedium: action.payload
            }
        case 'CLEAR_ACTIVE_MEDIUM':
            return {
                ...state,
                activeMedium: null
            }
        default:
            return state
    }
}

class TopStories extends Component {

    static propTypes = {
        stories: PropTypes.array,
        inFrame: PropTypes.func,
    }

    constructor(props) {
        super(props);
        let currentCategory = CATEGORY_CLASS_MAP[this.props.router.params.currentFilter];

        this.state = filterState({
            currentCategory: currentCategory || null, 
            mobileAction: 'categories'
        }, {});
    }

    dispatch(action) {
        this.setState(prevState => filterState(prevState, action));
    }

    setFilter = (category) => {
        document.getElementById('topStoryContainer').scrollTop = 0;
        this.props.router.push(`/stories/${category.className}`);
        this.dispatch({
            type: 'SET_FILTER',
            payload: category
        })
    }

    clearFilter = () => {
        document.getElementById('topStoryContainer').scrollTop = 0;
        this.props.router.push(`/stories`);
        this.dispatch({
            type: 'CLEAR_FILTER'
        })
    }

    setFilterPreview = (category) => {
        this.dispatch({
            type: 'SET_FILTER_PREVIEW',
        payload: category
        })
    }

    clearFilterPreview = () => {
        this.dispatch({
            type: 'CLEAR_FILTER_PREVIEW'
        })
    }

    setActiveMedium = (medium) => {
        this.dispatch({
            type: 'SET_ACTIVE_MEDIUM',
            payload: medium,
        })
    }

    clearActiveMedium = () => {
        this.dispatch({
            type: 'CLEAR_ACTIVE_MEDIUM',
        })
    }

    toggleHeader = () => {
        if (this.state.mobileAction === 'close') {
            this.dispatch({type: 'MOBILE_CLOSE'});
        } else {
            this.dispatch({type: 'MOBILE_OPEN'});
        }
    }

    sendToRoot() {
        this.props.router.push('/');
        this.props.router.go('/');
    }

    // Render mobile & desktop header
    renderHeader = () => {
        let activeCategory = this.state.currentCategory || {className: null};
        return (
            <div>
                <div
                    className={classNames(root.logoLarge, root.clickable)}
                    onClick={this.sendToRoot.bind(this)}
                />
                <div className={root.mobileHeader}>
                    <div className={root.logo}>
                        <div
                            className={classNames(root.logoSmall, root.clickable)}
                            onClick={this.sendToRoot.bind(this)}
                        />
                    </div>
                    <div className={classNames(
                        root.activeCategory,
                        root[`${activeCategory.className}`]
                    )}>
                        {this.state.currentCategory ? this.state.currentCategory.label : ''}
                    </div>
                    <div className={root.headerAction} onClick={this.toggleHeader}>
                        {this.state.mobileAction}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (typeof this.props.inFrame === 'function' && this.props.inFrame() === false) {
            return null;
        }
        let categoryMinutes = this.state.currentCategory ?
                              CATEGORY_TIME_MAP[this.state.currentCategory.className]:
                              CATEGORY_TIME_MAP['all'];

        let filterContainerStyles = classNames(
            styles.filterContainerOuter,
            this.state.mobileAction === 'close' ? styles.open : styles.close,
        );

        return (
            <div className={styles.container} ref="top-stories-container">
                {this.renderHeader()}

                <div className={filterContainerStyles}>
                    <div className={styles.filterContainerInner}>
                        <CategoryFilter
                            currentCategory={this.state.currentCategory}
                            onSetCategory={this.setFilter.bind(this)}
                            onClearCategory={this.clearFilter.bind(this)}
                            onSetPreview={this.setFilterPreview}
                            onClearPreview={this.clearFilterPreview}
                            onHoverMedium={this.setActiveMedium}
                            onClearHover={this.clearActiveMedium}
                        />
                    </div>
                </div>

                <div className={styles.storyContainer} id="storyContainer">
                    <TotalCounter
                        total={categoryMinutes.minutes}
                        context={categoryMinutes.text}
                    />
                    <div className={styles.smallCategoryContainer}>
                        <CategoryPanel
                            currentCategory={this.state.currentCategory}
                            size={'small'}
                        />
                    </div>
                    <StoryList stories={STORIES}
                        currentCategory={this.state.currentCategory}
                        currentMedium={this.state.activeMedium}
                        currentFilteredCategory={this.state.previewCategory}
                    />
                </div>

                <div className={styles.categoryContainer}>
                    <CategoryPanel
                        currentCategory={this.state.currentCategory}
                        size={'large'}
                    />
                </div>
                <div className={root.returnToTop} onClick={this.sendToRoot.bind(this)}>Back to Intro</div>
                <div className={classNames(styles.shareButtons, root.share)}>
                    <a href="http://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2F2016.chartbeat.com%2F&amp;src=sdkpreparse" target="_blank"><div className={root.facebookLogo} /></a>
                    <a href="http://twitter.com/home?status=What a year it's been! Check out who made the @Chartbeat list of the most engaging stories of 2016: http://chart.bt/2016" target="_blank"><div className={root.twitterLogo} /></a>
                </div>
            </div>
        );
    }
}

export default withRouter(TopStories);



// WEBPACK FOOTER //
// ./src/containers/top-stories/top-stories.js